/** @format */

export interface InvalidEmailError {
  error: string;
  message: string;
  path: string;
  status: number;
  timestamp: number;
  ui_messaging: {
    button?: {
      action: string;
    };
    identifier?: string;
    message?: string;
  };
}
